<template>
    <div class="inactiveClientClass">
        <div class="o-ndividualTable" v-loading="loading">
            <div 
                infinite-scroll-disabled="busy" 
                infinite-scroll-distance="10" 
                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                ref="scrollContainer"
                style="min-height: 1px;overflow:auto;"
            >
                <div 
                    class="o-custom-table-container c-common-box-shadow c-radius3 inactive-client-list-table-align" 
                    v-for="(client,key) in clients" :key="key"
                    v-if="client.user && client.user.length !=0"
                >
                    <div class="o-calls-table c-common-gradient">
                        <div class="calls-table-row phonesheet-table-row">
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Client:</span>
                                            <div>{{client.user.first_name+" "+client.user.last_name}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Contact Person:</span>
                                        <div>{{client.contact_person}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Phone:
                                                <el-tooltip class="item" effect="dark" content="Click to Copy Phone" placement="top-start">
                                                    <a @click.stop="copyText(''+client.contact_phone, 'phone')"><i class="fa fa-paste"></i></a>
                                                </el-tooltip>
                                            </span>
                                            <div>{{client.contact_phone}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Email ID:
                                                <el-tooltip class="item" effect="dark" content="Click to Copy Email" placement="top-start">
                                                    <a @click.stop="copyText(client.user?client.user.email:'', 'email')"><i class="fa fa-paste"></i></a>
                                                </el-tooltip>
                                            </span>
                                            <div>{{client.user.email}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Users:</span>
                                        <div>{{client.client_employees.length+"/"+(client.max_user == 999999?'Unlimited':client.max_user)}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Sign up:</span>
                                        <div>{{client.created_at}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Notes:</span>
                                        <div>{{client.note}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="">
                                    <div class="o-accordion-subtext o-rowtable-text text-center">
                                        <a href="javascript: void(0)" 
                                            @click="goToLogin(client.subdomain, client.user?client.user.id:'')" 
                                            class="o-client-view"><i class="fa fa-eye" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="o-table-extend-area u-pad-all-5 text-left o-table-extend-area--superadmin">
                        <ul class="o-table-extend">
                            <li>
                                <a href="javascript: void(0)" @click="editClient(client)" class="o-super-edit-icon">
                                    <i class="fa fa-pencil" aria-hidden="true"></i> Edit
                                </a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="goToManageEx(client)" class="o-super-manage-icon">
                                    <i class="fa fa-server" aria-hidden="true"></i> Manage Exceptions
                                </a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="activate(client.id,key)" class="o-super-deactive-icon">
                                    <i class="fa fa-eye-slash" aria-hidden="true"></i> Activate
                                </a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="deleteClient(client.id,key)" class="o-super-delete-icon">
                                    <i class="fa fa-trash" aria-hidden="true"></i> Delete
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-if="clients.length == 0 && afterAPI == true" class="c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3">
                <div class="col-md-12 no-job-dispaly">
                    <i class="fa fa-frown-o" aria-hidden="true"></i>
                    <br />
                    No Data Stored
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import {
        global
    } from '../../global.js';
    export default {

        computed: {
            ...mapGetters({
                userToken: 'userToken'

            })
        },
        props: ['myProp'],
        watch: {
            myProp: function(newVal) {
                if (newVal == "") {
                    this.getClientList();
                } else {
                    if (newVal.length > 3) {
                        service.get('client/searchClient', {
                                'Authorization': this.userToken,

                                'searchClient': newVal
                            })
                            .then((res) => {
                                this.searchData = res.data.result;

                                this.clients = [];
                                for (var i = 0; i < this.searchData.length; i++) {
                                    if (this.searchData[i].is_active == 0) {
                                        this.clients.push(this.searchData[i]);

                                    }


                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                    }
                }
            }
        },
        data() {
            return {
                loading:false,
                clients: [],
                next_page_url: null,
                savedClients: [],
                afterAPI: false
            }
        },
        methods: {
            copyText(text, type) {
                if (type == 'phone') {
                    if (text.length == 10) {
                        text = '+1' + text;
                    } else if (text.length == 11) {
                        text = '+' + text;
                    }
                }
                var textarea = document.createElement("textarea");
                textarea.textContent = text;
                textarea.style.position = "fixed";
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    document.execCommand("copy");
                    this.$notify({
                        title: 'Success',
                        message: 'Copied to clipboard.',
                        type: 'success'
                    });
                } catch (ex) {
                    console.warn("Copy to clipboard failed.", ex);
                    return false;
                } finally {
                    document.body.removeChild(textarea);
                }
            },
            async handleScroll() {
                // #2045 — same fix as skillList.vue (#1331): `position` was never declared here, so
                // this threw a ReferenceError and loadMore() never ran. v-infinite-scroll only calls
                // the handler at the bottom.
                await this.loadMore();
            },
            
            async loadMore() {
                if (!this.savedClients || this.savedClients.length == 0) return;
                var arr = this.clients;
                if (this.savedClients.length != 0) {
                    this.savedClients.forEach(function(entry) {
                        arr.push(entry);
                    })

                    this.savedClients = [];
                    if (this.next_page_url) {
                        await service.getUrl(this.next_page_url, {
                            'Authorization': this.userToken
                        })
                        .then((newClients) => {
                            this.savedClients = newClients.data.result.data;
                            this.next_page_url = newClients.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },
            editClient(client) {
                this.$store.dispatch('setClient', {
                    'id': client.id

                });
                this.$router.push({
                    'path': '/editClient'
                });
            },
            goToManageEx(client) {
                this.$store.dispatch('setClient', {
                    'id': client.id

                });
                this.$router.push({
                    'path': '/manageExceptions'
                });
            },
            deleteClient(id, key) {
                this.$confirm('This will permanently delete the client. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.loading=true;
                    service.del('client/' + id, {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        this.loading=false;
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Client Deleted Successfully.',
                            type: 'success'
                        });
                        this.clients.splice(key, 1);
                        this.$router.push({
                            'path': '/clientList'
                        });
                    }).catch((err) => {
                        this.loading=false;
                        console.log(err);
                    });
                    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            activate(id, key) {
                this.$confirm('This will activate the selected client. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('client/' + id + "/changeStatus", {
                            status: 1
                        }, {
                            'Authorization': this.userToken
                        })
                        .then((res) => {
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Client Activated Successfully.',
                                type: 'success'
                            });
                            this.clients.splice(key, 1);

                        }).catch((err) => {
                            console.log(err);
                        });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Activation cancelled'
                    });
                });
            },
            getClientList() {
                this.$Progress.start();
                this.loading=true;
                service.get('client/inactiveClients', {
                    'Authorization': this.userToken
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.clients = res.data.result.data;
                    this.next_page_url = res.data.result.next_page_url;
                    this.loading=false;
                    this.afterAPI = true;
                    if (res.data.result.next_page_url != null) {
                        // page 2 of the INACTIVE list — this used to fetch GET client (the active list)
                        service.getUrl(res.data.result.next_page_url, {
                            'Authorization': this.userToken
                        })
                        .then((newClients) => {
                            this.savedClients = newClients.data.result.data;
                            this.next_page_url = newClients.data.result.next_page_url;                                

                        }).catch((err) => {
                            console.log(err);
                        });
                    }

                }).catch((err) => {
                    console.log(err);
                });
            },
            goToLogin(subdomain , clientId) {
                this.$Progress.start();
                service.get('universal_login', {
                    'Authorization': this.userToken,
                    'userid': clientId,
                    'url': "http://" + subdomain + "." + global[0].CLIENT_BASE,
                })
                .then((res) => {
                    if (res.data.status_message != "Login successful") {
                        this.$Progress.fail();
                    } else {
                        this.$store.dispatch('userSession', res);
                        this.$cookies.set("csLogin", res.data.role.slug, "23h");
                        this.$cookies.set("date_format", res.data.user.employees[0].date_format, "23h");
                        this.$cookies.set("time_format", res.data.user.employees[0].time_format, "23h");
                        this.$Progress.finish();
                        $('.wrapper').css('margin-left', '60px');
                        if (res.data.role.slug != "super-admin") {
                            this.$cookies.set("time_zone", res.data.user.employees[0].client[0].clients.timezone, "23h");
                            var notifyType = (res.data.user.employees[0].email_notification == 1) ? 'email' : 'sms';
                            this.$store.dispatch('setNotificationType', notifyType);
                            this.$store.dispatch('setClientdata', res.data.user.employees[0].client[0].clients);
                            this.$store.dispatch('setSelectedJobFilter', {'parent': 'Myjob', 'child': 'Myjob'});
                            if (res.data.role.slug == "client-admin" || res.data.role.slug == "power-user") {
                                this.$router.push({
                                    path: "/jobList"
                                });
                            } else {
                                this.$router.push({
                                    path: "/schedule/"+btoa(this.employeeId),
                                });
                            }
                        } else {
                            this.$router.push({
                                path: "/clientList"
                            });
                        }
                    }
                }).catch((err) => {
                    console.log(err);
                });
            }
        },
        created() {
            this.getClientList();

        }
    }

</script>
<style scoped>
/* ── Mobile card layout (Galaxy S6 = 360px) ── */
@media (max-width: 820px) {
    .inactiveClientClass >>> .o-custom-table-container {
        margin-bottom: 10px;
    }
    .inactiveClientClass >>> .o-calls-table .calls-table-row {
        display: flex !important;
        flex-wrap: wrap !important;
    }
    .inactiveClientClass >>> .o-calls-table .calls-table-row .calls-table-cell {
        display: block !important;
        width: 100% !important;
        padding: 4px 10px !important;
        text-align: left !important;
    }
    .inactiveClientClass >>> .calls-table-cell .table-td-border-right {
        border-right: none !important;
        border-bottom: 1px solid rgba(0,0,0,0.06);
        padding-bottom: 4px;
    }
    .inactiveClientClass >>> .o-accordion-subtext span {
        font-size: 10px;
        text-transform: uppercase;
        opacity: 0.6;
    }
    .inactiveClientClass >>> .o-accordion-subtext div {
        font-size: 14px;
        word-break: break-word;
    }
    .inactiveClientClass >>> .o-table-extend-area {
        padding: 6px 10px !important;
    }
    .inactiveClientClass >>> .o-table-extend {
        display: flex !important;
        flex-wrap: wrap;
        gap: 8px;
    }
    .inactiveClientClass >>> .o-table-extend li {
        margin: 0 !important;
    }
    .inactiveClientClass >>> .o-table-extend li a {
        font-size: 12px;
        white-space: nowrap;
    }
}
</style>
